enum ContentType {
    Json = 'application/json',
    JsonV1 = 'application/vnd.bc.v1+json',
}

export default ContentType;
